import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ar',
  templateUrl: './ar.component.html',
  styleUrls: ['./ar.component.css']
})
export class ARComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}

/*
 * Need to fetch the current patient
 * Need to show a list of treatments for the patient
 * Need to link these treatments to a entry in the ledger
 * 
 *
 */
